import React, { lazy, Suspense } from "react";

// ---------------------------------------------------------------------------
// Landing Page — Figma node 103:28 (랜딩페이지 / 00_main)
//
// Main frame is a flex-column with gap:160px between every section, per
// Figma Dev Mode. We keep the Hero outside the `.landing__sections` wrapper
// because it has its own nav bleed logic (negative margin-top to sit behind
// the transparent 74px nav). Content sections (why, product, customer,
// banner) sit inside the flex-column so the 160px gap between sections is
// applied exactly once — no double-counting from per-section padding.
//
// Spacing spec (from Figma auto-layout):
//   .landing__sections  : flex-col gap-[160px]
//   first section top   : 160px (via padding-top on wrapper; hero → why)
//   internal per-section gaps: see each component / scss file
// ---------------------------------------------------------------------------

import Hero from "../components/landing/Hero";
import Why from "../components/landing/Why";
import Product from "../components/landing/Product";
import Banner from "../components/landing/Banner";

// 우진 (2026-05-08): Customer 컴포넌트 + 그가 import 하는 cases data (120KB
// chunk) 가 첫 진입 chunk 부담 큼. Customer 는 Landing 의 중간 섹션 (Why,
// Product 다음) 이라 첫 화면에 안 보임 → React.lazy 로 분할해 viewport
// 도달 시점에 chunk 다운로드. WebKit (iPhone) 에서 첫 paint 까지 평가해야
// 할 JS 약 120KB+ 줄어 paint 빨라짐. min-height placeholder 로 layout
// shift 방지.
const Customer = lazy(() => import("../components/landing/Customer"));

// The global footer is rendered by App.js (components/Footer.js).

export default function Landing() {
  return (
    <main className="landing">
      <Hero />
      <div className="landing__sections">
        <Why />
        <Product />
        <Suspense
          fallback={
            <div
              aria-hidden="true"
              style={{ minHeight: "800px" }}
            />
          }
        >
          <Customer />
        </Suspense>
        <Banner />
      </div>
    </main>
  );
}
